import React, { useState } from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import './BillingInfo.scss';
import { connect } from 'react-redux';

const dropDown = '/img/drop-down-2.svg';
const dropUp = '/img/drop-up-2.svg';

const BillingInfo = (props) => {
  const { handleEdit, billing } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [expand, setExpand] = useState(false);
  const openPopper = Boolean(anchorEl);

  const screenMd = useMediaQuery('(max-width: 960px)');

  const handlePopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleExpand = () => {
    setExpand(!expand);
  };

  return (
    <div className="billingInfo">
      <div className="billingInfo-header">
        <p>Datos de facturación</p>
        <MoreVertIcon
          color="primary"
          className="billingInfo-options"
          onClick={handlePopper}
        />
        <Popover
          open={openPopper}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'center',
            horizontal: 'right',
          }}
        >
          <List
            component="nav"
            aria-label="opciones"
          >
            <ListItem
              button
            >
              <ListItemText
                onClick={handleEdit}
                primary="Editar datos"
              />
            </ListItem>
          </List>
        </Popover>
      </div>

      <Grid container spacing={screenMd ? 2 : 3}>
        <Grid item xs={12} md={4}>
          <div className="billingInfo-content">
            <p>Nombre del abogado o despacho</p>
            <p>{billing.nameLawyerOrLawFirm}</p>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <div className="billingInfo-content">
            <p>Uso de CFDI</p>
            <p>
              {billing.cfdi ? billing.cfdi.description : ''}
            </p>
          </div>
        </Grid>

        <Grid item xs={12} md={4}>
          <div className="billingInfo-content">
            <p>RFC</p>
            <p>{billing.rfc}</p>
          </div>
        </Grid>
      </Grid>

      <div
        className={!expand && 'billingInfo-secondary'}
        style={expand ? { display: 'initial' } : null}
      >
        <Grid container spacing={screenMd? 2 : 3} >
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content" style={{paddingTop: screenMd? 8 : 0}}>
              <p>Correo electrónico</p>
              <p>{billing.invoiceEmail}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Número telefónico</p>
              <p>{billing.invoicePhoneNumber}</p>
            </div>
          </Grid>
          {billing && billing.zipCode ? (<><Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>País</p>
              <p>{billing.country}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Código postal</p>
              <p>{billing.zipCode}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Estado</p>
              <p>{billing.states}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Ciudad</p>
              <p>{billing.city}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Colonia</p>
              <p>{billing.neighborhood}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Calle</p>
              <p>{billing.street}</p>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className="billingInfo-content">
              <p>Número</p>
              <p>{billing.outdoorNumber}</p>
            </div>
          </Grid></>): ('')}
          
        </Grid>
      </div>
      
      <div className="billingInfo-seeButton-container">
        <button className="billingInfo-seeButton-button" onClick={() => handleExpand()}>
          {expand ? (
            <>
              <span>Ver menos</span>
              <img src={dropUp} alt="drop up" />
            </>
          ) : (
            <>
              <span>Ver más</span>
              <img src={dropDown} alt="drop up" />
            </>
          )}
        </button>
      </div>

    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  
})

const mapStateToProps = (state) => ({
  modalPayments: state.ModalReducer.openModalPayments,
  billing: state.billingReducer.billingData,
  laywerUid: state.authClient.uid,
  role: state.authClient.role,
});

export default connect(mapStateToProps, mapDispatchToProps)(BillingInfo);
